module.exports = "<template>\r\n    <require from=\"./spinner.css\"></require>\r\n\r\n    <div class=\"spinner\"></div>\r\n</template>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/spinner/circle-spinner.html
// module id = app/components/spinner/circle-spinner.html
// module chunks = 0